export default class OpenAssistService {
    constructor(endpoint) {
        this._endpoint = endpoint;
    }

    async ask(questionAnswer, metadata) {
        const response = await fetch(this._endpoint, {
            method: "POST",
            cache: "no-cache",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({questionAnswer, metadata}),
        });
        if(response.status !== 200) {
            throw new Error(`Request to OpenAssistService is failed. Status: ${response.status}`);
        }

        const result = await response.json();
        if(result.error) {
            throw new Error(`Request to OpenAssistService is failed. Error: ${result.error}`);
        }

        return result.response;
    }
}